import { render, staticRenderFns } from "./ReceiptSend.vue?vue&type=template&id=78f4b14c&scoped=true&"
import script from "./ReceiptSend.vue?vue&type=script&lang=js&"
export * from "./ReceiptSend.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptSend.vue?vue&type=style&index=0&id=78f4b14c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f4b14c",
  null
  
)

export default component.exports